export const SET_ACTIONS = 'GET_ACTIONS'
export const SET_ACTION_COMPLETE = 'SET_ACTION_COMPLETE'
export const SET_SHOW_COMPLETE_ACTIONS = 'SET_SHOW_COMPLETE_ACTIONS'
export const SET_DOWNLOADING_ACTIONS = 'SET_DOWNLOADING_ACTIONS'
export const UPDATE_ACTION = 'UPDATE_ACTION'
export const SET_SELECTED_ACTION = 'SET_SELECTED_ACTION'
export const RESET_STATE = 'RESET_STATE'
